import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const processCampaignChassis = (id, chassis) =>
  apiActionCreator({
    'endpoint': `/campaing/chasis/${id}`,
    'authenticated': true,
    'types': [
      ActionTypes.PROCESSING_CAMPAIGN_CHASSIS,
      [
        ActionTypes.PROCESSED_CAMPAIGN_CHASSIS,
        MessageActions.addMessageBoxInfo(
          'Archivo importado satisfactoriamente'
        ),
      ],
      [
        ActionTypes.PROCESSED_CAMPAIGN_CHASSIS_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'contentType': 'application/json',
    'method': 'POST',
    'data': {chassis},
  });

export const downloadCampaignChassisExcel = (id) =>
  apiActionCreator({
    'endpoint': `/campaing/query/excel/${id}`,
    'authenticated': true,
    'types': [
      ActionTypes.DOWNLOAD_CAMPAIGN_CHASSIS_EXCEL_REQUEST,
      ActionTypes.DOWNLOAD_CAMPAIGN_CHASSIS_EXCEL_SUCCESS,
      [
        ActionTypes.DOWNLOAD_CAMPAIGN_CHASSIS_EXCEL_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'contentType': 'application/json',
    'method': 'GET',
  });


export const removeElementFromChassis = (id, chassis, index) =>
  apiActionCreator({
    'endpoint': `/campaing/chasis/${id}`,
    'authenticated': true,
    'types': [
      ActionTypes.REMOVING_ELEMENT_FOR_CAMPAIGN_CHASSIS,
      [
        ActionTypes.REMOVED_ELEMENT_FOR_CAMPAIGN_CHASSIS,
        MessageActions.addMessageBoxInfo('Registro chasis eliminado con exito'),
      ],
      [
        ActionTypes.REMOVED_ELEMENT_FOR_CAMPAIGN_CHASSIS_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'contentType': 'application/json',
    'method': 'DELETE',
    'data': {chassis},
  });

export const clearChassisExcelFile = () => {
  return {
    'type': ActionTypes.CLEAR_CHASSIS_EXCEL_FILE,
  };
};
